/**
 * Accordion JS/Styles
 */

import Accordion from 'accordion-js';

document.addEventListener('DOMContentLoaded', function () {
	if ( 0 < document.querySelectorAll('.accordion-container').length ) {
		
		// Basic accordions
		const accordions = Array.from(document.querySelectorAll('.accordion-container:not(.session-accordion)'));
		accordions.forEach(accordion => {
			const toggles = Array.from(accordion.querySelectorAll('.ac-trigger'));
			toggles.forEach(toggle => {
				toggle.innerHTML = `<button class="ac-trigger">${toggle.innerHTML}</button>`;
				toggle.classList.remove('ac-trigger');
			});
		});

		// Sessions list accordions
		const sl_accordions = Array.from(document.querySelectorAll('.accordion-container.session-accordion'));

		var sl_toggles = new Accordion(sl_accordions, {
			duration: 400,
			showMultiple: true
		});
		var toggles = new Accordion(accordions, {
			duration: 400,
			showMultiple: false,
			beforeOpen: () =>{
				for (const toggle of toggles) {
					toggle.closeAll()
				}
			}
		});
	}

}, false);